import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Card from '../../components/Card/Card';
import Button from '../../components/Button/Button';
import styles from './Membership.module.css';

const Membership = () => {
  return (
    <div className={styles.membership}>
      {/* Header */}
      <section className={styles.header}>
        <h1 className={styles.pageTitle}>Membership</h1>
        <p className={styles.pageSubtitle}>Join the Idoma Medical Doctors Foundation</p>
      </section>

      {/* Eligibility */}
      <section className={styles.eligibility}>
        <div className={styles.eligibilityGrid}>
          <div className={styles.eligibilityContent}>
            <SectionTitle title="Who Can Join" subtitle="Eligibility" />
            <p className={styles.eligibilityText}>
              Membership is open to all Medical and Dental Practitioners of Idoma ethnic origin, either by birth or marriage, irrespective of rank, gender, religion, or political party affiliation.
            </p>
            <p className={styles.eligibilityText}>
              Membership is conferred only upon payment of the prescribed dues.
            </p>
          </div>
          <div className={styles.eligibilityImage}>
            {/* Placeholder image */}
          </div>
        </div>
      </section>

      {/* Dues Structure */}
      <section className={styles.dues}>
        <SectionTitle title="Membership Dues" subtitle="Investment in our community" align="center" />
        <div className={styles.cardGrid}>
          <Card title="Registration Dues" variant="elevated" className={styles.duesCard}>
            <p className={styles.duesAmount}>One‑time fee</p>
            <p className={styles.duesDescription}>
              A once‑for‑all charge as prescribed from time to time by the Congress.
            </p>
          </Card>
          <Card title="Annual Dues" variant="elevated" className={styles.duesCard}>
            <p className={styles.duesAmount}>Yearly subscription</p>
            <p className={styles.duesDescription}>
              Payable per year; amount determined by the Congress. Keeps your membership active.
            </p>
          </Card>
        </div>
        <p className={styles.duesNote}>
          * Exact amounts are communicated to members upon application and at annual general meetings.
        </p>
      </section>

      {/* Member Privileges – emojis removed */}
      <section className={styles.privileges}>
        <SectionTitle title="Member Privileges" subtitle="What you gain" align="center" />
        <div className={styles.benefitsGrid}>
          <div className={styles.benefitItem}>
            <h3>Voting Rights</h3>
            <p>Full floor and voting privileges on all Foundation business, including elections and bylaws.</p>
          </div>
          <div className={styles.benefitItem}>
            <h3>Leadership Opportunities</h3>
            <p>Eligibility to hold office and serve on committees.</p>
          </div>
          <div className={styles.benefitItem}>
            <h3>Welfare Support</h3>
            <p>Participation in events celebrating joy or offering support in times of need (bereavement, etc.).</p>
          </div>
          <div className={styles.benefitItem}>
            <h3>Publications</h3>
            <p>Access to the Journal of Medical Research and Practice and the IMDF newsletter.</p>
          </div>
          <div className={styles.benefitItem}>
            <h3>Networking</h3>
            <p>Connect with fellow Idoma medical professionals across Nigeria and the diaspora.</p>
          </div>
          <div className={styles.benefitItem}>
            <h3>Advocacy</h3>
            <p>Be part of engagements with government and international organisations on health issues.</p>
          </div>
        </div>
      </section>

      {/* How to Join */}
      <section className={styles.howToJoin}>
        <SectionTitle title="How to Join" subtitle="Simple steps" align="center" />
        <div className={styles.steps}>
          <div className={styles.step}>
            <span className={styles.stepNumber}>1</span>
            <h3>Express Interest</h3>
            <p>Contact our Secretary General or fill the inquiry form below.</p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepNumber}>2</span>
            <h3>Submit Application</h3>
            <p>Provide your credentials and proof of Idoma origin (birth or marriage).</p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepNumber}>3</span>
            <h3>Pay Dues</h3>
            <p>Pay the registration and annual dues as prescribed.</p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepNumber}>4</span>
            <h3>Welcome!</h3>
            <p>Once confirmed, you gain full membership privileges.</p>
          </div>
        </div>
      </section>

      {/* Inquiry Form / Call to Action */}
      <section className={styles.cta}>
        <Card variant="elevated" className={styles.ctaCard}>
          <h3>Ready to join?</h3>
          <p>Complete the expression of interest form, and our membership committee will reach out.</p>
          <Link to="/contact">
            <Button variant="primary" size="large">Contact Us to Join</Button>
          </Link>
          <p className={styles.ctaNote}>
            Alternatively, email us directly at <strong>membership@imdf.org.ng</strong>
          </p>
        </Card>
      </section>

      {/* Termination Note */}
      <section className={styles.termination}>
        <p className={styles.terminationText}>
          <strong>Note:</strong> Membership may be terminated by death, voluntary withdrawal, or by a two‑thirds vote for violations of the Foundation's purposes (see Article IX: Discipline). Members in arrears for two years lose their membership and must re‑register after paying outstanding dues.
        </p>
      </section>
    </div>
  );
};

export default Membership;